var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('account-layout',[_c('div',{staticClass:"account"},[_c('b-container',{staticClass:"pt-4"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }